import { makeStyles, Theme, createStyles, withStyles } from '@material-ui/core/styles';
import { blue, green, orange, pink, red } from '@material-ui/core/colors';
import { InputBase } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  header: {
    padding: `${theme.spacing(1.75)}px ${theme.spacing(3)}px`,
  },
  title: {
    flexGrow: 1,
    margin: theme.spacing(1),
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
    marginTop: theme.spacing(6),
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
  logo: {
    margin: theme.spacing(2),
  },
  infoContainer: {
    disply: 'flex',
    marginBottom: theme.spacing(1),
    height: '25%',
  },
  infoBar: {
    width: '30%',
    height: '100%',
  },
  margin: {
    margin: theme.spacing(1),
  },
  applyButton: {
    width: 142,
    borderRadius: '0 4px 4px 0',
    height: 50,
    color: theme.palette.background.paper,
    fontSize: 14,
    textTransform: 'none',
    boxShadow: 'none',
    marginRight: theme.spacing(1),
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  select: {
    margin: theme.spacing(1),
    //width: '30%',
  },
  addNewButton: {
    height: 50,
    fontSize: 14,
    textTransform: 'none',
    boxShadow: 'none',
    //margin: theme.spacing(1),
    color: theme.palette.getContrastText(blue[500]),
    backgroundColor: '#5081FF',
    '&:hover': {
      backgroundColor: blue[700],
    },
  },
  box: {
    marginBottom: theme.spacing(3),
  },
  headerBtn: {
    boxShadow: 'none',
    textTransform: 'none',
    lineHeight: '36px',
    padding: `0 ${theme.spacing(3)}px`,
    height: 50,
  },
  noBorder: {
    border: 'none',
  },
  btnAdd: {
    boxShadow: theme.shadows[0],
    padding: theme.spacing(1, 1),
    marginLeft: theme.spacing(2),
    minWidth: 64,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#5081FF',
    borderRadius: 4,
    '&:hover': {
      backgroundColor: 'rgb(0, 87, 178)',
      boxShadow:
        '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)',
    },
    '& svg': {
      fill: '#ffffff',
    },
  },
  dataGrid: {
    width: '100%',
    '& .MuiDataGrid-root .MuiDataGrid-row.Mui-selected ': {},
    '& .MuiDataGrid-root .MuiDataGrid-row': {
      '&:hover': {
        backgroundColor: 'rgba(255, 80, 95, 0.04)',
      },
    },
    '& .row-background-error': {
      backgroundColor: red[50],
      '&:hover': {
        backgroundColor: red[100],
      },
    },
    '& .row-background-alert': {
      backgroundColor: pink[50],
      '&:hover': {
        backgroundColor: pink[100],
      },
    },
    '& .row-background-transaction': {
      backgroundColor: 'white',
      '&:hover': {
        backgroundColor: 'rgba(255, 80, 95, 0.04)',
      },
    },
    '& .cell-text-color-error': {
      color: pink[700],
    },
    '& .cell-text-color-alert': {
      color: orange[700],
    },
    '& .cell-text-color-transaction': {
      color: 'black',
      fontWeight: '500',
      textTransform: 'capitalize',
    },
    '& .MuiDataGrid-colCellTitle': {
      color: 'black',
      fontWeight: '700',
      textTransform: 'capitalize',
    },
    '& .MuiDataGrid-colCellCheckbox, & .MuiDataGrid-cellCheckbox': {
      order: -1,
    },
  },
  link: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '100px',
    flexGrow: 1,
    fontWeight: 600,
    fontFamily: 'Roboto',
    fontSize: '20px',
    lineHeight: '27px',
  },
  page: {
    padding: '30px',
    background: '#f5f7fb',
    minHeight: '100vh',
  },
  card: {
    position: 'relative',
    borderRadius: '18px',
    padding: '10px',
    height: '180px',
    cursor: 'default',
    transition: '0.3s',
    border: '1px solid #e5e7eb',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
  },
  approvedCard: {
    borderTop: '4px solid #22c55e',
  },
  deniedIcon: {
    color: '#9ca3af',
  },
  pendingIcon: {
    color: '#f59e0b',
  },
  appRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '18px',
    marginTop: '25px',
  },
  appIcon: {
    width: '58px',
    height: '58px',
    objectFit: 'contain',
  },
  appName: {
    fontWeight: 700,
    fontSize: '20px',
    color: '#111827',
  },
  appDesc: {
    color: '#6b7280',
    fontSize: '14px',
    marginTop: '6px',
  },
  topIcon: {
    position: 'absolute',
    top: 16,
    right: 16,
    fontSize: 28,
  },
  approvedIcon: {
    color: '#22c55e',
  },
}));

export const useStylesSecond = makeStyles((theme: Theme) => ({
  label: {
    minWidth: 'auto',
    maxWidth: 'inherit',
    padding: 0,
    fontWeight: 500,
    fontSize: 14,
  },

  title: {
    flexGrow: 1,
    fontSize: 14,
    margin: theme.spacing(1),
  },
  gridPaper: {
    height: '100%',
  },
  tabsPaper: {
    width: '100%',
    boxShadow: theme.shadows[0],
    backgroundColor: 'transparent',
    '& [class*="MuiBox-root"]': {
      padding: theme.spacing(2, 0, 0, 0),
    },
  },
  tabsPanel: {
    padding: 12,
    width: '100%',
  },
  tabBox: {
    //backgroundColor: '#ffffff',
    //marginTop: theme.spacing(2.5),
  },
  tab: {
    //backgroundColor: '#ffffff',
    marginTop: theme.spacing(2.5),
  },
  container: {
    width: '100%',
  },
  row: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(3.5),
  },
  titlePopSmtp: {
    width: 170,
    margin: theme.spacing(0, 5, 0, 0),
    color: 'rgb(0 0 0 / 87%)',
  },
  desc: {
    width: 320,
    borderBottom: '1px solid #E0E0E0',
    padding: 5,
    color: 'rgb(0 0 0 / 87%)',
  },
  tabs: {
    width: 'fit-content',
    border: '1px solid white',
    borderRadius: '4px 0px 0px 4px',
    background: 'white',
    '& .MuiTabs-indicator': {
      backgroundColor: 'orange',
      height: 3,
    },
    '& .MuiTab-root.Mui-selected': {
      color: 'white',
      backgroundColor: '#5081FF',
    },
    '& .MuiTab-root': {
      padding: '16px 24px',
    },
  },
  badge: {
    position: 'relative',
    left: theme.spacing(-2),
  },

  page: {
    padding: '30px',
    background: '#f5f7fb',
    minHeight: '100vh',
  },
  card: {
    position: 'relative',
    borderRadius: '18px',
    padding: '10px',
    height: '180px',
    cursor: 'default',
    transition: '0.3s',
    border: '1px solid #e5e7eb',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
  },
  approvedCard: {
    borderTop: '4px solid #22c55e',
  },
  deniedIcon: {
    color: '#9ca3af',
  },
  pendingIcon: {
    color: '#f59e0b',
  },
  appRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '18px',
    marginTop: '25px',
  },
  appIcon: {
    width: '58px',
    height: '58px',
    objectFit: 'contain',
  },
  appName: {
    fontWeight: 700,
    fontSize: '20px',
    color: '#111827',
  },
  appDesc: {
    color: '#6b7280',
    fontSize: '14px',
    marginTop: '6px',
  },
  topIcon: {
    position: 'absolute',
    top: 16,
    right: 16,
    fontSize: 28,
  },
  approvedIcon: {
    color: '#22c55e',
  },
}));
export const BootstrapInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
    },
    input: {
      width: theme.spacing(20),
      borderRadius: '4px 0 0 4px',
      position: 'relative',
      background: theme.palette.action.hover,
      fontSize: 14,
      padding: 16,
    },
  })
)(InputBase);
